<template>
  <div class="d-flex align-center justify-center position-relative">
    <template v-if="
      $constants.situacoesMatriculaCondition[
      removerEspaco(matricula.situacao ? matricula.situacao : '')
      ]
    ">
      <v-currency-field locale="pt-BR" :default-value="null" :value="getFormattedValue()" :auto-decimal-mode="true"
        :value-as-integer="false" @input="handleInput" hide-details :allow-negative="false" dense :min="min" :max="max"
        :decimal-length="1" ref="input" v-bind="{ outlined: true }" v-bind:style="{
          'min-width': '60px !important',
          'max-width': '65px !important',
        }" :disabled="disabled" :tabindex="tabindex">
        <pre>{{ getFormattedValue }}
        </pre>
      </v-currency-field>
    </template>

    <template v-else-if="tipoValor === 'valor_texto'">
      <v-select v-if="notaTexto" @change="verificarVal($event)" :items="optionsNotaTexto"
        :item-value="(value) => value.descricao" :item-text="(value) => value.descricao" :value="getNotaTextoValue()"
        label="Selecione um tipo" outlined :disabled="disabled" :tabindex="tabindex" />

      <v-select v-else-if="valorSelect" @change="verificarVal($event)" :items="optionsNotaTexto"
        :item-value="(value) => value.descricao" :item-text="(value) => value.descricao" :value="valorSelect"
        label="Selecione um tipo" outlined :disabled="disabled" :tabindex="tabindex" />

      <v-select v-else @change="verificarVal($event)" :items="optionsNotaTexto" :item-value="(value) => value.descricao"
        :item-text="(value) => value.descricao" label="Selecione um tipo" outlined :disabled="disabled"
        :tabindex="tabindex" />
    </template>

    <template v-else>
      <v-currency-field locale="pt-BR" :default-value="null" :value="getFormattedValue()" :auto-decimal-mode="true"
        :value-as-integer="false" @input="handleInput" hide-details :allow-negative="false" dense :min="min" :max="max"
        :decimal-length="1" ref="input" v-bind="{ outlined: true }" v-bind:style="{
          'min-width': '60px !important',
          'max-width': '65px !important',
        }" :disabled="disabled" :tabindex="tabindex" />
    </template>

    <e-modal-info @closeModal="showModal = false" :dadosModal="dadosModal" :showModal="showModal" />
  </div>
</template>

<script>
import EModalInfo from "./EModalInfo.vue";

export default {
  components: {
    EModalInfo,
  },

  props: {
    arredondamento: {
      type: [Number, Boolean],
    },

    circuitoId: {
      type: Number,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    etapaAtual: {
      type: Number,
    },

    matricula: {
      type: Object,
      required: true,
    },

    max: {
      type: Number,
      default: 10,
    },

    min: {
      type: Number,
      default: 0,
    },

    notaTexto: {
      type: Object,
      required: false,
    },

    notaTextoLetra: {
      type: String,
    },

    tipoValor: {
      type: String,
    },

    valMax: {
      type: Number,
      default: null,
    },

    value: {
      type: [String, Number],
    },

    tabindex: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      dadosModal: {
        titulo: null,
        mensagem1: null,
        mensagem2: null,
        botao: null,
      },
      optionsNotaTexto: [],
      showModal: false,
      valorSelect: null,
      internalValue: null,
    };
  },

  computed: {
    shouldShowClearButton() {
      const currentValue = this.getCurrentValue();

      return (
        currentValue !== null && currentValue !== undefined && currentValue !== "" && !this.disabled
      );
    },

    currentMax() {
      return this.valMax !== null ? this.valMax : this.max;
    },
  },

  mounted() {
    this.getOptionsSelect();
    this.initializeInternalValue();
  },

  watch: {
    etapaAtual(value) {
      if (this.notaTextoLetra) {
        this.valorSelect = this.notaTextoLetra;
      } else {
        this.valorSelect = value;
      }
    },

    value: {
      handler(newVal) {
        this.internalValue = newVal;
      },
      immediate: true,
    },

    valMax() {
      const currentValue = this.getCurrentValue();
      if (currentValue !== null && currentValue !== undefined && currentValue > this.currentMax) {
        this.$emit("input", this.currentMax);
        this.$emit("change", this.currentMax);
      }
    },
  },

  methods: {
    initializeInternalValue() {
      this.internalValue = this.value;
    },

    getCurrentValue() {
      if (this.value !== undefined && this.value !== null) {
        return this.value;
      }

      if (this.notaTexto && this.notaTexto.valor !== undefined) {
        return this.notaTexto.valor;
      }

      if (this.internalValue !== undefined && this.internalValue !== null) {
        return this.internalValue;
      }

      return null;
    },

    getNotaTextoValue() {
      if (this.notaTexto && this.notaTexto.valor_texto) {
        return this.notaTexto.valor_texto;
      }

      if (this.notaTexto && this.notaTexto.valor) {
        return this.notaTexto.valor;
      }

      if (this.valorSelect) {
        return this.valorSelect;
      }

      return null;
    },

    getFormattedValue() {
      const currentValue = this.getCurrentValue();
      if (currentValue === null || currentValue === undefined || currentValue === "") {
        return null;
      }

      return parseFloat(currentValue).toFixed(1);
    },

    emitNull() {
      this.internalValue = null;
      this.$emit("input", null);
      this.$emit("change", null);

      setTimeout(() => {
        if (this.$refs.input && this.$refs.input._data) {
          this.$refs.input._data.formattedValue = "";
        }
      }, 150);
    },

    exibirModal(maximo) {
      this.dadosModal = {
        titulo: "Ops! O valor digitado é muito alto",
        mensagem1: `Insira um valor igual ou abaixo de ${maximo}.`,
        botao: "Ok",
      };

      this.showModal = true;
    },

    async getOptionsSelect() {
      try {
        const circuito = await this.$services.circuitoNotasService.getCircuito(this.circuitoId);

        this.optionsNotaTexto = circuito.valores_notas_texto || [];
      } catch (error) {
        this.optionsNotaTexto = [];
      }
    },

    handleInput(val) {
      if (val === null || val === undefined || val === "" || Number.isNaN(val)) {
        this.internalValue = null;
        this.$emit("input", null);
        this.$emit("change", null);
        return;
      }

      let processedVal = parseFloat(val);
      if (isNaN(processedVal)) {
        this.internalValue = null;
        this.$emit("input", null);
        this.$emit("change", null);
        return;
      }

      processedVal = Number(processedVal);

      if (processedVal > this.currentMax) {
        this.$emit("anularValor");
        this.exibirModal(this.currentMax);
        this.internalValue = null;
        this.$emit("input", null);
        this.$emit("change", null);
      } else if (processedVal < this.min) {
        this.internalValue = this.min;
        this.$emit("input", this.min);
        this.$emit("change", this.min);
        if (this.$refs.input && this.$refs.input.$emit) {
          this.$refs.input.$emit("input", this.min);
        }
      } else {
        this.internalValue = processedVal;
        this.$emit("input", processedVal);
        this.$emit("change", processedVal);
      }
    },

    removerEspaco(string) {
      if (!string) return "";
      return string.replace(" ", "_").replace(" ", "_").replace(" ", "_");
    },

    verificarVal($event) {
      this.$emit("add", $event);
    },
  },
};
</script>
